<!-- <header class="top-nav">
    <div class="top-nav__content">
        <button (click)="toggleFlowVisibility.emit(false)" class="top-nav__close">
            <i class="material-icons">close</i>
        </button>
    </div>
</header> -->
<div class="top-nav__content icon-close">
    <button (click)="toggleFlowVisibility.emit(false)" class="top-nav__close">
        <i class="material-icons">close</i>
    </button>
</div>
<div class="container-modal-update-data">
    <p class="ibk-description text-bold">
        Actualiza tus datos de contacto
    </p>
    <div class="ba-field-group d-block">
        <ol>
            <li>Ac&eacute;rcate a cualquiera de nuestras <a target="_blank"
                    href="https://interbank.pe/puntos-de-atencion" class="ibk-link">tiendas Interbank</a> con tu
                Documento de Identidad para solicitar la
                actualizaci&oacute;n.</li>
            <li>
                Una vez actualizados, ingresa nuevamente para validar tu identidad correctamente.
            </li>
        </ol>
    </div>

    <ibk-button class="ba-action">
        <button id="modal-update-your-data" class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn"
            (click)="toggleFlowVisibility.emit(false)">
            Entendido
        </button>
    </ibk-button>
</div>